import React from "react";
import PlayerAssetsPage from "./PlayerAssetsPage";
import { PLAYER_ASSET_TYPES } from "../../../constants/playerAssetTypes";

const PlayerMusicPage = () => <PlayerAssetsPage config={PLAYER_ASSET_TYPES.background_music} />;

export default PlayerMusicPage;
